import {
    Input,
    HostBinding
} from '@angular/core';

import { Appearance } from './appearance';
import { Evaluation } from '../utils/evalutaion';

/**
 * Base class for all components which hold common properties
 */
export abstract class Layout extends Appearance {
    // io
    /**
     * Specifies the component's height
     */
    get height(): number | string | Function {
        return this._height;
    }
    @Input() set height(value: number | string | Function) {
        this._height = Evaluation.evaluateToStyleWidthHeight(value);
    }
    /**
     * Specifies the component's width
     */
    get width(): number | string | Function {
        return this._width;
    }
    @Input() set width(value: number | string | Function) {
        this._width = Evaluation.evaluateToStyleWidthHeight(value);
    }
    
    // host bindings
    @HostBinding('style.height') private _height: string;
    @HostBinding('style.width') private _width: string;
}



// WEBPACK FOOTER //
// ./client-src/app/core/baseObjects/layout.ts